__turbopack_context__.v({
  "color-accent": "Icon-module-scss-module__9F5uRW__color-accent",
  "color-error": "Icon-module-scss-module__9F5uRW__color-error",
  "color-muted": "Icon-module-scss-module__9F5uRW__color-muted",
  "color-primary": "Icon-module-scss-module__9F5uRW__color-primary",
  "color-success": "Icon-module-scss-module__9F5uRW__color-success",
  "color-warning": "Icon-module-scss-module__9F5uRW__color-warning",
  "icon": "Icon-module-scss-module__9F5uRW__icon",
  "size-2xl": "Icon-module-scss-module__9F5uRW__size-2xl",
  "size-3xl": "Icon-module-scss-module__9F5uRW__size-3xl",
  "size-4xl": "Icon-module-scss-module__9F5uRW__size-4xl",
  "size-5xl": "Icon-module-scss-module__9F5uRW__size-5xl",
  "size-inherit": "Icon-module-scss-module__9F5uRW__size-inherit",
  "size-lg": "Icon-module-scss-module__9F5uRW__size-lg",
  "size-md": "Icon-module-scss-module__9F5uRW__size-md",
  "size-sm": "Icon-module-scss-module__9F5uRW__size-sm",
  "size-xl": "Icon-module-scss-module__9F5uRW__size-xl",
  "size-xs": "Icon-module-scss-module__9F5uRW__size-xs",
});
